import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Skeleton from "@mui/material/Skeleton";
import { use } from "react";
import { eventBus } from "../../utils/eventBus";

const DiagnosisPopup = ({ isOpen,appid, onClose,setAlertMessage,setSeverity,setOpen, }) => {
  const [inputText, setInputText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedsearch,setSelectedSearch]=useState([])
  const [isSuggestionSelected, setIsSuggestionSelected] = useState(false);
  const { id=appid?.appointmentid ,dt} = useParams();
  const appointmentInfo = useSelector((state) => state.appinfo.appointmentInfo);
  const [initialData, setInitialData] = useState([]);
  const [isFetchingConditions, setIsFetchingConditions] = useState(false);
  const practiseid = window.getPracticeId();
  const userConfig = useSelector((state) => state.userconfig);
  const [selectedSnomed, setSelectedSnomed] = useState([]);
  useEffect(() => {
    if (inputText.trim() === "" || isSuggestionSelected) {
    
      setIsSuggestionSelected(false);
      return;
    }

    const delayDebounceFn = setTimeout(() => {
      fetchSuggestions();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [inputText]);

  const fetchSuggestions = async () => {
    try {
      setLoading(true);
      const response = await api.post(
        `/v1/${practiseid}/orders/patient/${id}/get-search-diagnosis`,
        {
          searchVal: inputText,
        }
      );
      if (response.status === 200) {
        setSuggestions(response.data);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestionClick = (item) => {
  setInputText('');

  // 🔹 Highlight using SNOMED
  setSelectedSnomed((prev) =>
    prev.includes(item.snomed_code)
      ? prev.filter((code) => code !== item.snomed_code)
      : [...prev, item.snomed_code]
  );

  // 🔹 Payload still uses ICD10
  setSelectedSearch((prev) =>
    prev.includes(item.icd10)
      ? prev.filter((code) => code !== item.icd10)
      : [...prev, item.icd10]
  );
};
  

  const handleTabClick = (id) => {
    setSelectedTabs((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((tabId) => tabId !== id)
        : [...prevSelected, id]
    );
  };

  const fetchData = async () => {
    try {
      setIsFetchingConditions(true);
      const response = await api.get(
        `/v1/${practiseid}/orders/patient/${appointmentInfo?.patientid}/condition`
      );
      if (response.status === 200) {
        setInitialData(response.pConditions);
      }
    } catch (error) {
      console.error("Error fetching patient conditions:", error);
    } finally {
      setIsFetchingConditions(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const handleSave=async()=>{
    const filteredIcd10Values = initialData
    .filter(item => selectedTabs.includes(item.id)) // Filter by matching IDs
    .map(item => item.icd10);
      const selectedsuggestions = await api.post(
        `/v1/${practiseid}/orders/patient/${appointmentInfo.patientid}/get-orders`,
        {
          appointmentid:appointmentInfo.appointmentid,
          // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
                  "orderdate":dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0])) 
             ? dt.split(' ')[0] 
             : appointmentInfo?.startdate &&  appointmentInfo?.startdate.includes(' ') && !isNaN(Date.parse( appointmentInfo?.startdate.split(' ')[0]))&& appointmentInfo?.startdate.split(' ')[0],
        }
      )
let prev = [];

if (selectedsuggestions?.status === 200) {
  const icdList = selectedsuggestions?.data?.diagnosis?.map((x) => x.icd10) || [];
  prev = [ ...icdList];
}

    try {
        const response= await api.post(`/v1/${practiseid}/patient/${appointmentInfo.patientid}/orders/confirm`,{
          "patient_name": `${appointmentInfo.firstname || ''} ${appointmentInfo.lastname || ''}`.trim(),
             "createdby": userConfig?.username||'',
            // "orderdate": data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
             "orderdate":dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0])) 
             ? dt.split(' ')[0] 
             : appointmentInfo?.startdate &&  appointmentInfo?.startdate.includes(' ') && !isNaN(Date.parse( appointmentInfo?.startdate.split(' ')[0]))&& appointmentInfo?.startdate.split(' ')[0],
            "tov": "2",
            "lov":appointmentInfo.lov,
            "diagnosis": [...filteredIcd10Values,...selectedsearch,...prev],
            "appointmentid":appointmentInfo.appointmentid,
            "token_no": 0,
            "confirm_status": "E",
            "update_status": "C"
          })
          if(response.status===200){
             eventBus.emit("fetchSummary")
            setAlertMessage(response.message)
            setSeverity("success")
            setOpen(true)
                setTimeout(() => {
                onClose()
                }, 2000);
          }else{
            setAlertMessage(response.message)
            setSeverity("info")
            setOpen(true)
                setTimeout(() => {
  onClose()
}, 2000);
          }
    } catch (error) {
        
    }finally{

    }
}
  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="relative flex flex-col gap-4 w-[60%] max-h-[80vh] bg-white px-4 pb-6 rounded-lg shadow-lg text-left overflow-hidden">
          <div>
            <div className="w-full flex items-center justify-between mt-2">
              <span className="ml-2 font-semibold text-[#1D2951] text-base text-center">
                Diagnosis
              </span>
              <button
                className="text-gray-500 hover:text-gray-700 text-[30px]"
                onClick={() => {
                  setInputText("");
                  setIsSuggestionSelected(true);
                  setSuggestions([]);
                  onClose();
                }}
              >
                &times;
              </button>
            </div>
            <div className="h-px bg-[#D0D5DD]"></div>
          </div>
          <div className="flex w-full flex-col sm:flex-row md:flex-row lg:flex-row">

         <div >
         <div className="relative w-full max-w-md mr-2">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            />
            <input
              type="text"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              className="rounded-[16px] w-[340px] border border-[#D5D5D5] bg-[#F5F6FA] pl-10 pr-16 py-1 text-base outline-none"
              placeholder="Search for diagnosis"
            />
         
          </div>
   <div className="w-full mt-2">
  {loading ? (
    <div className="text-sm text-gray-500">Getting suggestions...</div>
  ) : inputText.trim() !== "" && suggestions.length === 0 ? (
    <div className="text-center text-sm text-gray-500">
      Suggestions not found!
    </div>
  ) : (
    <div className="w-full flex flex-wrap gap-1 max-h-[250px] overflow-y-auto custom-scrollbar">
      {/* {suggestions.map((item) => (
        <div
          key={item.id}
          onClick={() => handleSuggestionClick(item)}
          className={`cursor-pointer font-poppins text-xs text-center rounded-full flex items-center justify-center px-3 py-2 my-1 ${
            selectedsearch.includes(item.icd10)
              ? "bg-[#e17954] text-white"
              : "bg-[#E5E7EB] text-[#1D2951]"
          }`}
        >
          {item.condition_name}
        </div>
      ))} */}
      {suggestions.map((item) => (
        <div
          key={item.id}
          onClick={() => handleSuggestionClick(item)}
          className={`cursor-pointer font-poppins text-xs text-center rounded-full flex items-center justify-center px-3 py-2 my-1 ${
           selectedSnomed.includes(item.snomed_code)
              ? "bg-[#e17954] text-white"
              : "bg-[#E5E7EB] text-[#1D2951]"
          }`}
        >
          {item.condition_name}
        </div>
      ))}
    </div>
  )}
</div>


         </div>
       

    <div> 
        <label className="text-[#111827] my-0 px-2">Problem List</label>
          <div className="w-full overflow-y-auto custom-scrollbar flex-grow max-h-[250px]">
      
            <div className="w-full flex flex-wrap">
              {isFetchingConditions ? (
                Array.from({ length: 6 }).map((_, index) => (
                  <Skeleton
                    key={index}
                    variant="rectangular"
                    width={100}
                    height={35}
                    style={{ margin: 8, borderRadius: "20px" }}
                  />
                ))
              ) : (
                initialData.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => handleTabClick(item.id)}
                    className={`cursor-pointer font-poppins text-xs text-center rounded-full border-[1px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                      selectedTabs.includes(item.id)
                        ? "bg-[#e17954] text-white"
                        : "bg-[#E5E7EB] text-[#1D2951]"
                    } px-3 h-[35px] m-2`}
                  >
                    {item.condition_name}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
</div>
          <div className="w-full flex justify-center mt-2">
            <button onClick={()=>handleSave()} className="rounded py-2 w-full px-4 text-[12px]  bg-[#18181B] text-[#FFFFFF]">
          Save
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default DiagnosisPopup;
